import React, { useRef } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Home from './pages/Home';
import GigaGod from './pages/GigaGod';

import './index.css'

export default function App() {
  const location = useLocation();
  const nodeRef = useRef(null); 

  return (
    <TransitionGroup component={null}>
      <CSSTransition
        key={location.pathname}
        classNames="fade"
        timeout={300}
        nodeRef={nodeRef}
      >
        <div ref={nodeRef}>
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/gigagod/*" element={<GigaGod />} />

          </Routes>
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
}
